"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressStepperStepDot = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
/**
 * Used by `ProgressStepperStep` to display an icon or dot that reflects a step's status.
 *
 * @since 8.57.0
 */
var ProgressStepperStepDot = /*#__PURE__*/_styledComponents.default.span.withConfig({
  displayName: "ProgressStepperStepDot",
  componentId: "c11n-8-100-7__sc-abxubx-0"
})([""]);
exports.ProgressStepperStepDot = ProgressStepperStepDot;
ProgressStepperStepDot.displayName = 'ProgressStepperStepDot';

/** @component */